export const TAB_CLASS_NAME = {
  'MD': 'tab_md',
  'LG': 'tab_lg'
} as const;

export const NCUA_VUES = [
  'MessageIframe',
];
